/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class PipelineWebhooksAPI extends ApiClient {
  constructor() {
    super('pipeline/webhooks', { accountScoped: true });
  }

  urlForAccount(accountId) {
    const normalizedAccountId =
      accountId === undefined || accountId === null
        ? ''
        : String(accountId).trim();
    if (!normalizedAccountId) {
      throw new TypeError('accountId is required');
    }

    return `${this.apiVersion}/accounts/${encodeURIComponent(normalizedAccountId)}/${this.resource}`;
  }

  get(accountId) {
    return axios.get(this.urlForAccount(accountId));
  }

  create(data, accountId) {
    return axios.post(this.urlForAccount(accountId), data);
  }

  update(id, data, accountId) {
    return axios.patch(`${this.urlForAccount(accountId)}/${id}`, data);
  }

  delete(id, accountId) {
    return axios.delete(`${this.urlForAccount(accountId)}/${id}`);
  }

  test(id, accountId) {
    return axios.post(`${this.urlForAccount(accountId)}/${id}/test`);
  }

  regenerateSecret(id, accountId) {
    return axios.patch(
      `${this.urlForAccount(accountId)}/${id}/regenerate_secret`
    );
  }
}

export default new PipelineWebhooksAPI();
